module.exports = "/virtual-football/img/video/clubs/france/lille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/france/lille.png
// module id = 290
// module chunks = 6